
import { computed, useRouter } from '@nuxtjs/composition-api'
import useColor from '~/composable/useColor';
import TlmButton from '@/components/TlmButton.vue';

export default {
  props: {
    bannerInfo: {
      type: Object,
      default: () => {}
    },
    brandLogo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TlmButton
  },
  setup(props) {
    const { getBackground, getTheme } = useColor()
    const router = useRouter()

    const actions = computed(() => {
      const list = props?.bannerInfo?.actions
      if (!Array.isArray(list)) {
        return []
      }
      return list
        .filter(Boolean)
        .map(a => ({
          label: a?.label ?? '',
          url: a?.url ?? '',
          type: a?.type ?? 'BUTTON',
          version: a?.version,
          newWindow: a?.newWindow !== false
        }))
        .filter(a => a.label && a.url)
    })

    const isBannerClickable = computed(() => actions.value.length === 1)

    const isExternalUrl = (url) => /^https?:\/\//i.test(String(url ?? '').trim())

    const getActionHref = (action) => {
      const url = String(action?.url ?? '').trim()
      if (!url) {
        return undefined
      }
      return isExternalUrl(url) ? url : undefined
    }

    const getActionTo = (action) => {
      const url = String(action?.url ?? '').trim()
      if (!url) {
        return undefined
      }
      if (action?.newWindow) {
        return undefined
      }
      return isExternalUrl(url) ? undefined : url
    }

    const navigateAction = (action) => {
      const url = String(action?.url ?? '').trim()
      if (!url) {
        return
      }
      if (action?.newWindow) {
        window.open(url, '_blank', 'noopener,noreferrer')
        return
      }
      if (isExternalUrl(url)) {
        window.location.assign(url)
        return
      }
      router.push(url)
    }

    const onActionClick = (action) => {
      navigateAction(action)
    }

    const onBannerClick = () => {
      if (!isBannerClickable.value) {
        return
      }
      navigateAction(actions.value[0])
    }

    const getVariant = (action) => {
      const version = String(action?.version || '').toLowerCase()
      if (version === 'primary' || version === 'secondary' || version === 'tertiary') {
        return version
      }
      return 'secondary'
    }

    const scrollToProduct = () => {
      document.querySelector('#campaign-anchor').scrollIntoView({
        behavior: 'smooth'
      });
    }

    return {
      actions,
      isBannerClickable,
      onBannerClick,
      onActionClick,
      getActionHref,
      getActionTo,
      getVariant,
      scrollToProduct,
      getTheme,
      getBackground
    }
  }
}
